export default __webpack_public_path__ + "images/OGN.058f0c9.png";